/* @flow */
/* eslint-disable babel/no-invalid-this */
import safeAccess from "safe-access";
import type { ValveFeature } from "./types";

export default function Valve(feature: ValveFeature) {
  let operateAction = feature.actions.operate;

  this.isValveClosed = () => {
    return this.get("status") === "closed";
  };

  this.isValveOperable = () => operateAction != null;

  this.getCurrentValveOperation = () => {
    return safeAccess(operateAction, "title");
  };

  this.operateValve = () => {
    if (!this.isValveOperable()) {
      return $.Deferred.reject(
        new Error("Attempted to operate an inoperable valve")
      );
    }
    return this.executeDeviceActionThenFetch(operateAction, {});
  };

  return { status: feature.status };
}



// WEBPACK FOOTER //
// ./src/models/mixins/device_features/valve.js